import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import VideoVert from "../components/VideoVert";
import Anchorsandbarcode from "../img/Anchorsandbarcode.png";
import Attachments from "../img/Attachments.png";
import Autocaptured from "../img/Autocaptured.jpg";
import AutovsManualMode from "../img/AutovsManualMode.jpg";
import Cameraangle from "../img/Cameraangle.jpg";
import Clicksubmit from "../img/Clicksubmit.jpg";
import customAS from "../img/customAS.png";
import genericAS from "../img/genericAS.png";
import gtip1 from "../img/gtip1.png";
import gtip2 from "../img/gtip2.png";
import Hidestudentanswers from "../img/Hidestudentanswers.png";
import Hidestudentanswerteacher from "../img/Hidestudentanswerteacher.png";
import onlineAS from "../img/onlineAS.png";
import Password from "../img/Password.png";
import PrintMCas from "../img/PrintMCas.png";
import Printmultiplechoiceanswersheets from "../img/Printmultiplechoiceanswersheets.png";
import Printmultiplechoiceanswersheets2 from "../img/Printmultiplechoiceanswersheets2.png";
import Printregularanswersheets from "../img/Printregularanswersheets.png";
import Printregularanswersheets2 from "../img/Printregularanswersheets2.png";
import Printregularanswersheets3 from "../img/Printregularanswersheets3.png";
import Printregularanswersheets4 from "../img/Printregularanswersheets4.png";
import Printregularanswersheets5 from "../img/Printregularanswersheets5.png";
import Release from "../img/Release.png";
import release1 from "../img/release1.png";
import Releaseontestsettingspage from "../img/Releaseontestsettingspage.png";
import Resultsshownaftereachscan from "../img/Resultsshownaftereachscan.jpg";
import Review from "../img/Review.png";
import Scan1 from "../img/Scan1.jpg";
import Scan2 from "../img/Scan2.jpg";
import Selectaclass from "../img/Selectaclass.jpg";
import Selectclassrespond from "../img/Selectclassrespond.png";
import Start1 from "../img/Start1.png";
import Start2 from "../img/Start2.png";
import Studentsanswerrespond from "../img/Studentsanswerrespond.png";
import Submittoviewresults from "../img/Submittoviewresults.png";
import Time from "../img/Time.png";
import tip1 from "../img/tip1.png";
import tip2 from "../img/tip2.png";
import tip3 from "../img/tip3.png";
import tip4 from "../img/tip4.png";
import Unrelease from "../img/Unrelease.png";
import Viewresultsrespond from "../img/Viewresultsrespond.png";
import blankAS from "../img/blankAS.png";
import prefilledAS from "../img/prefilledAS.png";
import custommc3 from "../img/custommc3.png";
import custommc2 from "../img/custommc2.png";
import custommc1 from "../img/custommc1.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",

      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  contentVert: {
    height: "650px",
    maxWidth: "450px",
    width: "70%",
    marginBottom: "70px",
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      width: "70%",
      marginBottom: "50px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "550px",
      width: "75%",
      margin: "0 auto",
      marginBottom: "40px",
    },
  },
  videoWrapperVert: {
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
    borderRadius: "4px",
  },
  frameVert: {
    position: "absolute",
    height: "650px",
    maxWidth: "450px",
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      height: "550px",
      width: "75%",
    },
  },
  vidDescVert: {
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function WhatAreAns() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          What are student answer sheets?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          Answer sheets are where students input their answers to your
          assessment questions.
        </Typography>
      </div>
    </div>
  );
}
function CanPaper() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Can paper answer sheets be printed on regular paper?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          Yes, our paper answer sheets can be printed on regular paper. We
          recommend printing on large page sizes such as A4.
        </Typography>
      </div>
    </div>
  );
}
function DifferencesMultiple() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Differences between multiple choice, written and online answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography displau="block" className={classes.details} variant="body2">
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            1. Multiple-choice answer sheets (paper)
          </span>{" "}
          can be used with any assessment that is purely multiple choice. This
          means that you can pre-print a stack of them at the start of the
          school year and use them as needed.
          <br />
          <br />
          Here is an example of a multiple-choice answer sheet:
        </Typography>
        <img className={classes.imgSize} src={genericAS} alt="Answer Sheet" />
        <Typography displau="block" className={classes.details} variant="body2">
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            2. Written answer sheets (paper)
          </span>{" "}
          are generated based on your answer key. For example, if you created a
          key with Q#1 as multiple choice and Q#2 as fill in the blank, it would
          need a different answer sheet than a key with both answers as fill in
          the blank.
          <br />
          <br />
          Due to this, written answer sheets only work with the assessment they
          were generated for.
          <br />
          <br />
          Here is an example of a written answer sheet:
        </Typography>
        <img className={classes.imgSize} src={customAS} alt="Answer Sheet" />
        <Typography displau="block" className={classes.details} variant="body2">
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            3. Online answer sheets (online)
          </span>{" "}
          can be released to students with just a few clicks. Once released,
          students can then access them by logging in to the SwiftGrade student
          portal on our website.
          <br />
          <br />
          Example of an online answer sheet:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={onlineAS}
          alt="Answer Sheet"
        />
      </div>
    </div>
  );
}
function PreInput() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Differences between our pre-filled and no-name answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          Paper answer sheets can be either ‘pre-filled’ or ‘no-name’.
          <br />
          <br />
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            Pre-filled answer sheets
          </span>{" "}
          have the student’s name printed on the sheet as well as their email
          encoded in the barcode of the sheet. This means you can always email
          the student their results. When you generate pre-filled answer sheets
          there will be one sheet for each student in your class.
          <img
            style={{ maxWidth: "400px" }}
            className={classes.imgSize}
            src={prefilledAS}
            alt="Answer Sheet"
          />
          <br />
          <br />
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            No-name answer sheets
          </span>{" "}
          are not specific to any student. Students write their name (and
          optionally their email) into the answer sheets. Only students who
          write their email in the answer sheets will be able to receive
          results.
          <br />
          <br />
          It is always a good idea that even if you use pre-filled answer sheets
          to print a few extra no-name ones just in case students make mistakes
          and need to start over with a fresh answer sheet.
          <img
            style={{ maxWidth: "400px" }}
            className={classes.imgSize}
            src={blankAS}
            alt="Answer Sheet"
          />
        </Typography>
      </div>
    </div>
  );
}
function PrintMultiple() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Print multiple choice answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howtoprintmult">
            How to print multiple choice answer sheets
          </a>
          <br />
          <br />
          <a href="#multipletips">Multiple choice answer sheet tips</a>
          <br />
          <br />
          <a href="#maximizeaccuracymult">
            Maximize grading accuracy with multiple choice answer sheets
          </a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtoprintmult"
        >
          How to print multiple choice answer sheets:
        </Typography>
        <Typography className={classes.details} variant="body2">
          You can only download multiple choice answer sheets from our website,
          not our app.
          <br />
          <br />
          To print multiple choice answer sheets, log in to the SwiftGrade
          website and click the bubble icon on your dashboard.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={PrintMCas}
          alt="Print answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          On the next page, click the download button.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printmultiplechoiceanswersheets}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          You can now print the downloaded PDF file which contains the student
          answer sheets.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="multipletips"
        >
          Multiple choice answer sheet tips:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              Multiple choice answer sheets are compatible with any assessment
              that is purely multiple choice. This means that you can pre-print
              a stack of them and use them as needed.
              <br />
              <br />
            </Typography>
          </li>
          <li>
            <Typography className={classes.details} variant="body2">
              Pre-input student names into the answer sheets by selecting ‘Yes’
              because then students can always receive results.
            </Typography>
          </li>
        </ul>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printmultiplechoiceanswersheets2}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          Note that you can only do this if you have students enrolled in your
          class.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="maximizeaccuracymult"
        >
          Maximize grading accuracy with multiple choice answer sheets:
        </Typography>
        <Typography className={classes.details} variant="body2">
          To maximize grading accuracy, please tell students to:
        </Typography>
        <br />
        <Typography
          display="block"
          className={classes.imgExplainerText}
          variant="body2"
        >
          Fill circles fully:
        </Typography>
        <img
          style={{ maxWidth: "350px" }}
          className={classes.imgSize3}
          src={gtip1}
          alt="Custom Tip 1"
        />
        <br />
        <Typography
          display="block"
          className={classes.imgExplainerText}
          variant="body2"
        >
          Use dark color pen or pencil:
        </Typography>
        <img
          style={{ maxWidth: "200px" }}
          className={classes.imgSize3}
          src={gtip2}
          alt="Custom Tip 2"
        />
      </div>
    </div>
  );
}
function PrintRegular() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Print written answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howtoprint">How to print written answer sheets</a>
          <br />
          <br />
          <a href="#regulartips">Written answer sheet tips</a>
          <br />
          <br />
          <a href="#maximizeaccuracy">
            Maximize grading accuracy with written answer sheets
          </a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtoprint"
        >
          How to print written answer sheets:
        </Typography>
        <Typography className={classes.details} variant="body2">
          Written answer sheets are used with any assessment that is NOT purely
          multiple choice.
          <br />
          <br />
          You can only download answer sheets for printing from our website, not
          our app. <br />
          <br />
          To print written answer sheets, click the ‘Print’ icon in the ‘Next
          step’ column. <br />
          <br />
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printregularanswersheets2}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          If you previously printed answer sheets and want to print some more,
          click the ‘More options’ button and then the ‘Print’ icon.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printregularanswersheets}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          On the next page, click the download button.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printregularanswersheets3}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          You can now print the downloaded PDF file which contains the student
          answer sheets.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="regulartips"
        >
          Written answer sheet tips:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              Written answer sheets are generated based on your answer key.
              Therefore, written answer sheets are only compatible with the
              class and assessment it was generated for.
              <br />
              <br />
            </Typography>
          </li>
          <li>
            <Typography className={classes.details} variant="body2">
              If students have been enrolled in your class SwiftGrade will
              pre-input their names into the answer sheets. This will ensure
              that students can always receive results.
              <br />
              <br />
            </Typography>
          </li>
          <li>
            <Typography className={classes.details} variant="body2">
              If using answer sheets that have student names pre-inputted, it’s
              a good idea to print a few extra generic sheets, just in case
              students make a mistake and need to start over with a fresh sheet.
              <br />
              <br />
            </Typography>
          </li>
        </ul>
        <Typography className={classes.details} variant="body2">
          Here is an example of printing 2 extra generic sheets:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printregularanswersheets4}
          alt="Answer Sheet"
        />
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Printregularanswersheets5}
          alt="Answer Sheet"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="maximizeaccuracy"
        >
          Maximizing grading accuracy with written answer sheets:
        </Typography>
        <Typography className={classes.details} variant="body2">
          To maximize grading accuracy, please tell students to:
          <br />
          <br />
        </Typography>
        <Typography
          display="block"
          className={classes.imgExplainerText}
          variant="body2"
        >
          Write with large and neat characters:
        </Typography>
        <img className={classes.imgSize3} src={tip3} alt="Custom Tip 1" />
        <br />
        <Typography
          display="block"
          className={classes.imgExplainerText}
          variant="body2"
        >
          Print characters(do not write cursive):
        </Typography>
        <img className={classes.imgSize3} src={tip1} alt="Custom Tip 2" />
        <br />
        <Typography
          display="block"
          className={classes.imgExplainerText}
          variant="body2"
        >
          Write inside the box:
        </Typography>
        <img className={classes.imgSize3} src={tip2} alt="Custom Tip 3" />
        <br />
        <Typography
          display="block"
          className={classes.imgExplainerText}
          variant="body2"
        >
          Completely erase mistakes:
        </Typography>
        <img className={classes.imgSize3} src={tip4} alt="Custom Tip 4" />
      </div>
    </div>
  );
}
function ScanPaper() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Scan paper answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howtoscanpaper">How to scan paper answer sheets</a>
          <br />
          <br />
          <a href="#bestprac">Best practices while scanning</a>
          <br />
          <br />
          <a href="#viewscan">View scan results</a>
          <br />
          <br />
          <a href="#manualauto">Manual vs. Automatic mode</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtoscanpaper"
        >
          How to scan paper answer sheets:
        </Typography>
        <Typography className={classes.details} variant="body2">
          You can scan answer sheets with our{" "}
          <span style={{ textDecoration: "underline" }}>Android</span> or{" "}
          <span style={{ textDecoration: "underline" }}>iOS</span> app, not our
          website.
          <br />
          <br />
          Once you log in to the app, select the class that your assessment is
          in:
          <br />
          <br />
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Selectaclass}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          Then click the scan icon:
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Scan1}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          If the assessment already has results, click options and then click
          scan:
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Scan2}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          This will open your camera and initiate the scanning session.
          <br />
          <br />
          Next, simply point your camera at an answer sheet and the image will
          be automatically captured for you. Once the image is captured a ‘Scan
          completed’ pop up will appear:
        </Typography>
        <img
          style={{ maxWidth: "600px" }}
          className={classes.imgSize3}
          src={Autocaptured}
          alt="Autocaptured"
        />
        <Typography className={classes.details} variant="body2">
          Repeat this process with all of the answer sheets, and once done,
          click Submit:
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Clicksubmit}
          alt="click submit"
        />
        <Typography className={classes.details} variant="body2">
          Student grades will now be ready for you in the results section.
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="bestprac">
          Best practices while scanning:
        </Typography>
        <ul>
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            The four squares and barcode should be visible:
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              While scanning, the four squares and the barcode must be clearly
              visible, void of shadows, and not be covered by student
              handwriting:
            </Typography>
          </li>

          <img
            style={{ maxWidth: "300px" }}
            className={classes.imgSize3}
            src={Anchorsandbarcode}
            alt="Ancors and bar code"
          />
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            Take a bright photo void of shadows and glare:
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              Make sure that you are scanning in a well lit room with minimal
              glare or shadows on the answer sheet. If you must scan in dark
              conditions, there is a flashlight icon, but this can reduce
              scanning and grading accuracy.
              <br />
              <br />
            </Typography>
          </li>
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            Take a flat photo:
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              Make sure the paper is not bent or crumpled, and that your camera
              is directly above the page instead of at an angle:
            </Typography>
          </li>
          <img
            style={{ maxWidth: "600px" }}
            className={classes.imgSize3}
            src={Cameraangle}
            alt="Camera angle"
          />
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            Don’t have other papers visible in the background.
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              Anchors or barcodes from other papers will disrupt the scanning
              process.
            </Typography>
          </li>
        </ul>

        <Typography className={classes.highlighted} variant="h6" id="viewscan">
          View scan results:
        </Typography>
        <Typography className={classes.details} variant="body2">
          For multiple choice answer sheets, results are shown after each scan:
        </Typography>

        <img
          className={classes.imgSize3}
          src={Resultsshownaftereachscan}
          alt="Results after scan"
        />
        <br />
        <Typography className={classes.details} variant="body2">
          For written answer sheets, results are only shown after you scan all
          papers and click Submit:
        </Typography>
        <img
          className={classes.imgSize3}
          src={Submittoviewresults}
          alt="Subit to view results"
        />
        <br />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="manualauto"
        >
          Automatic vs. Manual mode:
        </Typography>
        <Typography className={classes.details} variant="body2">
          There are two scanning modes, Auto, and Manual:
        </Typography>
        <img
          className={classes.imgSize3}
          style={{ maxWidth: "600px" }}
          src={AutovsManualMode}
          alt="Subit to view results"
        />
        <Typography className={classes.details} variant="body2">
          SwiftGrade is meant to scan in Auto mode.
          <br />
          <br />
          In Auto mode, the image will be captured as soon as the answer sheet
          is in the correct position.
          <br />
          <br />
          In Manual mode, you need to manually click the shutter button to
          capture the image.
          <br />
          <br />
          Only use manual mode if scanning seems slow or is not working. This is
          usually because your phone’s processing power is too low for auto
          scanning.
        </Typography>
      </div>
    </div>
  );
}
function ReleaseOnlineAns() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Release online answer sheets to students
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howtorelease">
            How to release online answer sheets to students
          </a>
          <br />
          <br />
          <a href="#answersettings">Online answer sheet settings</a>
          <br />
          <br />
          <a href="#howtounrelease">How to un-release online answer sheets</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtorelease"
        >
          How to release online answer sheets to students:
        </Typography>
        <Typography className={classes.details} variant="body2">
          To release online answer sheets to students, click the ‘Up arrow’ icon
          in the ‘Next step’ column:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={release1}
          alt="release"
        />
        <Typography className={classes.details} variant="body2">
          If there are results already, then click the ‘More options’ button and
          then the ‘Up arrow’ icon:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Release}
          alt="Release"
        />
        <Typography className={classes.details} variant="body2">
          On the next page, choose your settings and click Release:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Releaseontestsettingspage}
          alt="Release on test settings"
        />
        <Typography className={classes.details} variant="body2">
          Now, the online answer sheets plus any files you may have attached
          will be available to the students who have enrolled in your class.
          <br />
          <br />
          Students can now respond in the online answer sheets by logging in to
          our website, clicking your class, and clicking start assessment.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="answersettings"
        >
          Online answer sheet settings:
        </Typography>
        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          Attaching test files:
          <br />
          <br />
        </Typography>

        <Typography className={classes.details} variant="body2">
          You can optionally attaching files such as your quiz or formula sheet:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Attachments}
          alt="Attachments"
        />
        <br />
        <Typography className={classes.details} variant="body2">
          PDF, Word, and Image files will be shown in the student section on a
          split screen with our answer sheets on the other half.
          <br />
          <br />
          All other file types will be available for students to download.
          <br />
          <br />
          You can upload a maximum of 5 files, with a total size of 50 MB.
          <br />
          <br />
        </Typography>
        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          Setting time limit
          <br />
          <br />
        </Typography>
        <Typography className={classes.details} variant="body2">
          If there is a time limit set:
        </Typography>
        <img
          className={classes.imgSize3}
          style={{ maxWidth: "400px" }}
          src={Time}
          alt="Time"
        />
        <Typography className={classes.details} variant="body2">
          then a student’s answer sheet will be automatically submitted once
          time has expired.
          <br />
          <br />
        </Typography>
        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          Displaying results when finished:
          <br />
          <br />
        </Typography>
        <Typography className={classes.details} variant="body2">
          If this setting is on:
        </Typography>
        <img
          className={classes.imgSize3}
          style={{ maxWidth: "400px" }}
          src={Review}
          alt="Review"
        />
        <Typography className={classes.details} variant="body2">
          then as soon as a student submits their answer sheet, they can view
          their results.
          <br />
          <br />
          If the setting is off, then students will only receive results when
          you manually release them.
          <br />
          <br />
        </Typography>
        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          Hide student answers.
          <br />
          <br />
        </Typography>
        <Typography className={classes.details} variant="body2">
          If this setting is on:
        </Typography>
        <img
          className={classes.imgSize3}
          src={Hidestudentanswerteacher}
          alt="Hide student answers teacher"
        />
        <Typography className={classes.details} variant="body2">
          then student answers will be covered to help prevent other students
          from glancing over and copying them.
          <br />
          <br />
          This is what a student’s answer sheet would look like depending on
          whether this setting was on or off:
        </Typography>
        <img
          className={classes.imgSize}
          style={{ maxWidth: "800px" }}
          src={Hidestudentanswers}
          alt="Hide student answers"
        />
        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          Release password
          <br />
          <br />
        </Typography>
        <Typography className={classes.details} variant="body2">
          If you set a password:
        </Typography>

        <img
          className={classes.imgSize3}
          src={Password}
          alt="Hide student answers"
        />
        <Typography className={classes.details} variant="body2">
          students will need this to start the online assessment.
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtounrelease"
        >
          How to un-release online answer sheets{" "}
        </Typography>
        <Typography className={classes.details} variant="body2">
          To un-release answer sheets, click the more options button, then the
          ‘Down arrow’
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Unrelease}
          alt="Unrelease"
        />
        <Typography className={classes.details} variant="body2">
          Now online answer sheets for this assessment will no longer be
          available to students.
        </Typography>
      </div>
    </div>
  );
}
function StudentsRespond() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          How students respond in online answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          Once you have released online answer sheets, they will be available
          for students in your class to take.
          <br />
          <br />
          Students can respond in these by following these student instructions:
          <br />
          <br />
          Log in and then click on your teacher’s class.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Selectclassrespond}
          alt="Select class"
        />
        <Typography className={classes.details} variant="body2">
          On the next page, you will see a list of all the assessments that your
          teacher has currently released. Click the ‘Rocket’ icon for the
          assessment you want to take:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Start1}
          alt="Start"
        />
        <Typography className={classes.details} variant="body2">
          On the next page, input the assessment password if asked, and then
          click start:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Start2}
          alt="Start"
        />
        <Typography className={classes.details} variant="body2">
          Now input your answers and when done click submit:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Studentsanswerrespond}
          alt="Students answer respond"
        />
        <br />
        <Typography className={classes.details} variant="body2">
          Now depending on your teacher’s settings, you may be able to view your
          results:
        </Typography>
        <img
          className={classes.imgSize}
          style={{ maxWidth: "800px" }}
          src={Viewresultsrespond}
          alt="View results"
        />
      </div>
    </div>
  );
}

function ScanningTips() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{ display: "inline-block" }}>
        <div>
          <Typography variant="h5" className={classes.fontHeading}>
            Tutorial video - How to scan student answer sheets
          </Typography>
          <VideoVert videoLink="https://www.youtube.com/embed/Qe5fRtTxxMw" />
        </div>
      </div>
    </div>
  );
}

function CustomizeAnswerSheets() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          How to customize Multiple-Choice Answer Sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          You can customize our multiple-choice answer sheets by setting the
          number of answers, letters, and sheets per page in just a few clicks.
          <br />
          <br />
          <span style={{ textDecoration: "underline" }}>
            Here's how to do it:
          </span>
          <br />
          <br />
          Visit your dashboard and click 'Print' in the top right:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={custommc3}
          alt="Customize MC"
        />
        <Typography className={classes.details} variant="body2">
          Now, see these three dropdowns:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={custommc2}
          alt="Start"
        />
        <Typography className={classes.details} variant="body2">
          Simply set the values to your liking, and the answer sheet will update
          to reflect your choices:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={custommc1}
          alt="Start"
        />
        <Typography className={classes.details} variant="body2">
          Finally, click download and your all set!
          <br />
          <br />
        </Typography>
        <Typography className={classes.details} variant="caption">
          Note that you can only customize multiple-choice answer sheets on our
          website, not our Android or iOS app.
        </Typography>
      </div>
    </div>
  );
}

function AnswerSheetsTopics() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/what-are-answer-sheets`}>
          <WhatAreAns />
        </Route>
        <Route path={`${path}/can-paper-answer-sheets-be-printed`}>
          <CanPaper />
        </Route>
        <Route path={`${path}/differences-multiple-choice`}>
          <DifferencesMultiple />
        </Route>
        <Route path={`${path}/pre-input-student-name`}>
          <PreInput />
        </Route>
        <Route path={`${path}/print-written-answer`}>
          <PrintRegular />
        </Route>
        <Route path={`${path}/print-multiple`}>
          <PrintMultiple />
        </Route>
        <Route path={`${path}/scan-paper-answer-sheets`}>
          <ScanPaper />
        </Route>
        <Route path={`${path}/release-online-answer`}>
          <ReleaseOnlineAns />
        </Route>
        <Route path={`${path}/how-students-respond-online`}>
          <StudentsRespond />
        </Route>
        <Route path={`${path}/tips-for-scanning-tutorial`}>
          <ScanningTips />
        </Route>
        <Route path={`${path}/customize-answer-sheets`}>
          <CustomizeAnswerSheets />
        </Route>
        <Route>
          <WhatAreAns />
        </Route>
      </Switch>
    </>
  );
}

export default AnswerSheetsTopics;
